module.exports = __webpack_public_path__ + "static/media/resource-nutrition.65c7936f.png";